import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-score-financiero',
  standalone: false,
  templateUrl: './score-financiero.component.html',
  styleUrl: './score-financiero.component.scss'
})
export class ScoreFinancieroComponent {

  sessionId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();
  }


  cotizacionEnPausa() {
    this.router.navigate(['./']);
  }
}
